export default function maskedCardNumber(number) {
    var maskedNumber = number.replace(/\d(?=\d{4})/g, "*");
    return maskedNumber
}